(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */
    angular
        .module('ihh-common-web')
        .directive('fullscreenHeight', fullscreenHeight);

    fullscreenHeight.$inject = ['$window', '$timeout'];

    /**
     * A directive for restricting the height of an element to fullscreen. This
     * directive listens for edit/non edit mode broadcast messages. Also allows for
     * the height of an element to be forced into fullscreen
     * @param {service} $timeout
     * @param {service} $window
     */
    function fullscreenHeight($window, $timeout) {
        return {
            restrict: 'A',
            scope: {
                /**
                 * When set, the page is assumed to be in edit mode
                 *
                 * @ngdoc property
                 * @name fullscreen-height-edit-flag
                 * @memberOf ihh-common-web.fullscreen-height
                 */
                fullscreenHeightEditFlag: '=',

                /**
                 * When set, the fullscreen directive will act as if it were in edit mode
                 *
                 * @ngdoc property
                 * @name fullscreen-height-edit-override
                 * @memberOf ihh-common-web.fullscreen-height
                 */
                fullscreenHeightEditOverride: '=',

                /**
                 * When set, this element has a class added to it that other instances of
                 * the directive can find, which allows it to recalculate height based on
                 * the new height of the dependable element.
                 *
                 * @ngdoc property
                 * @name fullscreen-height-edit-dependable
                 * @memberOf ihh-common-web.fullscreen-height
                 */
                fullscreenHeightDependable: '='
            },
            link: function(scope, element) {
                var isEditModeCss = {
                    'max-height': 0,
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden'
                };
                var isNotEditModeCss = {
                    'max-height': 'inherit',
                    'overflow-y': 'inherit',
                    'overflow-x': 'inherit'
                };

                /**
                 * This function calculates the max allowable height of our element,
                 * taking into account a possible tabbed element which provides a
                 * minimum value for the height for our element.
                 * @param {type} element
                 * @returns {Number} maxHeight
                 */
                var calculateMaxHeight = function(element) {
                    var itemChooserContainerAncestorElement = angular.element(element).parents('.item-chooser-container');
                    var doubleNavAncestorElement = angular.element(element).parents('.double-navbar-top-body');
                    var tabContentAncestorElement = angular.element(element).parents('.tab-content');
                    var footerElement = angular.element('.copyright');

                    var maxHeight = $window.innerHeight;

                        // since the footer has a clearfix, we may have to account for the positional change
                    if (footerElement.length > 0) {
                        var footerHeight = footerElement.outerHeight(true);
                        maxHeight -= footerHeight;
                    }

                    if (doubleNavAncestorElement.length > 0) {
                        var doubleNavAncestorHeight = parseInt(doubleNavAncestorElement.css('marginTop'), 10);
                        maxHeight -= doubleNavAncestorHeight;
                    }

                    if (tabContentAncestorElement.length > 0) {
                        var tabsElement = tabContentAncestorElement.siblings('.nav.nav-tabs');
                        var tabsHeight = 0;
                        var heightBelowTabs = 0;

                        var tabContentMarginBottomHeight = 20;
                        var tabContentBorderBottomHeight = 1;

                        for (var i = 0; i < tabsElement.length; i++) {
                            tabsHeight += angular.element(tabsElement[i]).outerHeight(true);
                            heightBelowTabs += (tabContentMarginBottomHeight + tabContentBorderBottomHeight);
                        }

                        maxHeight -= (tabsHeight + heightBelowTabs);
                    }

                    if (itemChooserContainerAncestorElement.length > 0) {
                            // since both search and who both have negative margin, we may have to account for that
                        var chooserWhoHeight = itemChooserContainerAncestorElement.find('.item-chooser-who').outerHeight(true);
                        var chooserSearchHeight = itemChooserContainerAncestorElement.find('.item-chooser-search').outerHeight(true);
                        maxHeight -= (chooserWhoHeight + chooserSearchHeight);

                        var panelBodyPaddingBottomHeight = 15;
                        maxHeight -= panelBodyPaddingBottomHeight;

                        var chooserSidebarHeight = itemChooserContainerAncestorElement.find('.item-chooser-sidebar').outerHeight(true);

                        if (maxHeight < chooserSidebarHeight) {
                            maxHeight = chooserSidebarHeight;
                        }
                    }
                    else {
                        var chooserTab = angular.element('.chooser-tabs');
                        var chooserTabHeight = chooserTab.find('.nav.nav-tabs').outerHeight(true);
                        var chooserTabContentHeight = chooserTab.find('.tab-pane.active').outerHeight();
                        var chooserHeight = chooserTabContentHeight + chooserTabHeight;

                        var miscHeight = 15;
                        maxHeight -= miscHeight;

                        if (maxHeight < chooserHeight) {
                            maxHeight = chooserHeight;
                        }
                    }


                    if (scope.fullscreenHeightDependable) {
                        element.addClass('fullscreen-height-dependable');
                    }

                    element.addClass('fullscreen-height');

                    return maxHeight + 'px';
                };

                if (scope.fullscreenHeightEditOverride || scope.fullscreenHeightEditFlag) {
                    $timeout(function() {
                        isEditModeCss['max-height'] = calculateMaxHeight(element);
                        element.css(isEditModeCss);
                    }, 200); // must wait for page to begin rendering 200 req. on protocol page
                }
                scope.$watch('fullscreenHeightEditFlag', function(newValue) {
                    $timeout(function() {
                        if (newValue) {
                            isEditModeCss['max-height'] = calculateMaxHeight(element);
                            element.css(isEditModeCss);
                        }
                        else if (newValue === false) {
                            element.css(isNotEditModeCss);
                        }
                    }, 50); // must wait for page to begin rendering 50 req. on page with changing editFlags
                });
                scope.$watch(function() {
                    var heights = [];
                    var dependables = angular.element('.fullscreen-height-dependable');
                    for (var i = 0; i < dependables.length; i++) {
                        heights.push(angular.element(dependables[i]).height());
                    }
                    return heights;
                }, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $timeout(function() {
                            if (scope.fullscreenHeightEditFlag || scope.fullscreenHeightEditOverride) {
                                isEditModeCss['max-height'] = calculateMaxHeight(element);
                                element.css(isEditModeCss);
                            }
                            else if (scope.fullscreenHeightEditFlag === false) {
                                element.css(isNotEditModeCss);
                            }
                        }, 50); // must wait for page to begin rendering 50 req. on page with changing editFlags
                    }
                }, true);
            }
        };
    }
})();